import RfiCreatedSuccessScreen from './RfiCreatedSuccessScreen.component';

export default RfiCreatedSuccessScreen;
